import { request } from './';

export const getFaqCategories = () => request('/faq-categories');
